module.exports = __webpack_public_path__ + "assets/img/block-left-hover-629ef1c6.png";